import axios from 'axios';

// const API_URL = 'http://192.168.168.101:5500/api';
// export const URL = 'http://192.168.168.101:5500/';
const API_URL = 'https://eyes.winggs.com/api';
export const URL = 'https://eyes.winggs.com/';
// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 10000
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Auth services
export const authAPI = {
  login: async (credentials) => {
    try {
      const response = await api.post('/auth/login', credentials);
      return response;
    } catch (error) {
      console.error('Login error:', error.response?.data || error.message);
      throw error;
    }
  },
  register: async (userData) => {
    try {
      const response = await api.post('/auth/register', userData);
      return response;
    } catch (error) {
      console.error('Registration error:', error.response?.data || error.message);
      throw error;
    }
  },
  logout: async () => {
    try {
      const response = await api.post('/auth/logout');
      localStorage.removeItem('token');
      return response;
    } catch (error) {
      console.error('Logout error:', error.response?.data || error.message);
      throw error;
    }
  },
  getCurrentUser: async () =>{
    try {
        const response = await api.get('/auth/me')
        return response;
    }   catch (error) {
        console.error('Get current user error:', error.response?.data || error.message);
        throw error;
    }
  },
  verifyOtp: async (data) => {
    try {
      const response = await api.post('/auth/verifyOtp', data);
      return response.data;
    } catch (error) {
      console.error('Verify OTP error:', error.response?.data || error.message);
      throw error;
    }
  },
  resendOtp: async (data) => {
    try {
      const response = await api.post('/auth/resendOtp', data);
      return response.data;
    } catch (error) {
      console.error('Resend OTP error:', error.response?.data || error.message);
      throw error;
    }
  }
};
// dashboard Services
export const dashboardService = {
  getCustomers: async (limit = 1) => {
    const response = await api.get(`/customers?limit=${limit}`);
    return response.data;
  },

  getPrescriptions: async (limit = 1) => {
    const response = await api.get(`/prescriptions?limit=${limit}`);
    return response.data;
  },

  getInvoices: async (limit = 1) => {
    const response = await api.get(`/invoices?limit=${limit}`);
    return response.data;
  },

  getPendingInvoices: async (limit = 1) => {
    const response = await api.get(`/invoices?paymentStatus=pending&limit=${limit}`);
    return response.data;
  },
};
//customer services
export const customerService = {
  getCustomerById: async (id) => {
    const response = await api.get(`/customers/${id}`);
    return response.data;
  },

  getPrescriptionsByCustomer: async (customerId) => {
    const response = await api.get(`/prescriptions?customer=${customerId}`);
    return response.data;
  },

  getInvoicesByCustomer: async (customerId) => {
    const response = await api.get(`/invoices?customer=${customerId}`);
    return response.data;
  },

  deleteCustomer: async (id) => {
    const response = await api.delete(`/customers/${id}`);
    return response.data;
  },
  addCustomer: async (data) => {
    const response = await api.post('/customers', data);
    return response.data;
  },

  updateCustomer: async (id, data) => {
    const response = await api.put(`/customers/${id}`, data);
    return response.data;
  },
  getCustomers: async (params) => {
    const response = await api.get('/customers', { params });
    return response;
  }
};

export default api;
